import { useState, useMemo, createContext, useContext } from 'react';
import { DriverInputOicdUser } from '@/generated/model/driverInputOicdUser';

type User = {
  name: string | undefined;
  email: string | undefined;
  kid: string | undefined;
  id: number | undefined;
  admin: boolean | undefined;
};

export type UserContext = {
  user: User | undefined;
  logout: () => void;
};

interface UserProviderProps extends React.PropsWithChildren {
  loggedInUser: DriverInputOicdUser | undefined | null;
  logout: () => void;
}

export const ctxUser = createContext<UserContext | undefined>(undefined);

export function UserProvider({ loggedInUser, logout, children }: UserProviderProps) {
  const [user] = useState<User | undefined>({
    name: loggedInUser?.name,
    email: loggedInUser?.email,
    kid: loggedInUser?.userName,
    id: loggedInUser?.personId,
    admin: loggedInUser?.admin,
  } satisfies User);

  const contextValue = useMemo(
    () => ({
      user,
      logout,
    }),
    [user, logout]
  );

  return <ctxUser.Provider value={contextValue}>{children}</ctxUser.Provider>;
}

export function useUserContext() {
  const context = useContext(ctxUser);
  if (!context) {
    throw new Error('User context must be used within a Provider');
  }

  return context;
}
